/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Conversion rate from BGN to EUR (fixed as of now)
const BGN_TO_EUR = 1.95583;

// Function to format price to 2 decimal places and keep locale formatting
function formatPrice(value) {
  return value.toFixed(2);
}

// Go through all text nodes in the document
function convertBGNtoEUR(container = document.body) {
  const walker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let node;
  while ((node = walker.nextNode())) {
    if (node.parentElement && node.parentElement.closest('.product-grid-item--card')) {
      continue;
    }
    const regex = /€\s*(\d+(?:[\.,]\d{1,2})?)/g;
    let matches = [...node.textContent.matchAll(regex)];

    if (matches.length > 0) {
      let newText = node.textContent;

      matches.forEach((match) => {
        let bgnString = match[1].replace(',', '.'); // normalize comma to dot
        let bgnValue = parseFloat(bgnString);

        if (!isNaN(bgnValue)) {
          let eurValue = bgnValue * BGN_TO_EUR;
          let eurFormatted = formatPrice(eurValue);

          let original = match[0];
          let replacement = `${original} (${eurFormatted} лв)`;

          newText = newText.replace(original, replacement);
        }
      });

      node.textContent = newText;
    }
  }
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', convertBGNtoEUR);
} else {
  convertBGNtoEUR();
}